/* AELYA theme — lightweight interactions. No dependencies. */
(function(){
  'use strict';
  var $ = function(s,c){return (c||document).querySelector(s);};
  var $$ = function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};

  /* ---- Mobile nav drawer ---- */
  document.addEventListener('click', function(e){
    var open = e.target.closest('[data-drawer-open]');
    var close = e.target.closest('[data-drawer-close]');
    var drawer = $('#nav-drawer');
    if(!drawer) return;
    if(open){ drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
    if(close || e.target === $('.drawer__scrim', drawer)){ drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
  });

  /* ---- Collection: mobile filter sheet ---- */
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-filter-toggle]')){
      var f = $('#facets'); if(f) f.classList.toggle('is-open');
    }
    if(e.target.closest('[data-filter-close]')){
      var f2 = $('#facets'); if(f2) f2.classList.remove('is-open');
    }
  });

  /* ---- Product gallery thumbs ---- */
  $$('[data-gallery]').forEach(function(g){
    var main = $('[data-gallery-main] img', g);
    $$('[data-gallery-thumb]', g).forEach(function(t){
      t.addEventListener('click', function(){
        if(!main) return;
        var src = t.getAttribute('data-src');
        if(src) main.src = src;
        $$('[data-gallery-thumb]', g).forEach(function(x){x.classList.remove('is-active');});
        t.classList.add('is-active');
      });
    });
  });

  /* ---- Installment calculator ---- */
  $$('[data-installment]').forEach(function(box){
    var price = parseFloat(box.getAttribute('data-price')) || 0;
    var out = $('[data-inst-result]', box);
    function render(months){
      var monthly = price>0 ? Math.ceil(price/months) : 0;
      if(out) out.innerHTML = box.getAttribute('data-label-from') + ' <b>' +
        monthly.toLocaleString() + ' ' + box.getAttribute('data-currency') + '</b> / ' +
        box.getAttribute('data-label-month') + ' &middot; ' + months + ' ' + box.getAttribute('data-label-months');
    }
    $$('[data-tenure]', box).forEach(function(b){
      b.addEventListener('click', function(){
        $$('[data-tenure]', box).forEach(function(x){x.classList.remove('is-active');});
        b.classList.add('is-active');
        render(parseInt(b.getAttribute('data-tenure'),10));
      });
    });
    var first = $('[data-tenure]', box);
    if(first){ first.classList.add('is-active'); render(parseInt(first.getAttribute('data-tenure'),10)); }
  });

  /* ---- Quantity steppers ---- */
  document.addEventListener('click', function(e){
    var dec = e.target.closest('[data-qty-dec]');
    var inc = e.target.closest('[data-qty-inc]');
    if(!dec && !inc) return;
    var wrap = e.target.closest('.qty');
    var input = $('input', wrap);
    if(!input) return;
    var v = parseInt(input.value,10) || 1;
    input.value = inc ? v+1 : Math.max(1, v-1);
    input.dispatchEvent(new Event('change',{bubbles:true}));
  });

  /* ---- Sticky mobile buy bar visibility ---- */
  var buyRow = $('[data-buy-anchor]');
  var stickyBuy = $('.sticky-buy');
  if(buyRow && stickyBuy && 'IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      stickyBuy.style.transform = entries[0].isIntersecting ? 'translateY(100%)' : 'translateY(0)';
    }).observe(buyRow);
  }

  /* ---- Countdown timer (deals) ---- */
  $$('[data-countdown]').forEach(function(el){
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    if(isNaN(end)){ end = Date.now() + 1000*60*60*26; }
    function tick(){
      var d = Math.max(0, end - Date.now());
      var h = Math.floor(d/3.6e6), m = Math.floor(d%3.6e6/6e4), s = Math.floor(d%6e4/1e3);
      var set = function(k,v){var n=$('[data-cd="'+k+'"]',el); if(n) n.textContent=(v<10?'0':'')+v;};
      set('h',h); set('m',m); set('s',s);
    }
    tick(); setInterval(tick,1000);
  });

  /* ---- A-Z brand jump ---- */
  $$('[data-az]').forEach(function(a){
    a.addEventListener('click', function(e){
      var t = $('#brand-letter-'+a.getAttribute('data-az'));
      if(t){ e.preventDefault(); window.scrollTo({top: t.getBoundingClientRect().top + window.scrollY - 150, behavior:'smooth'}); }
    });
  });

  /* ---- Section entrance animations ---- */
  if(window.Shopify && window.Shopify.designMode){
    /* In the theme editor: show everything immediately and re-show re-rendered sections */
    $$('[id^="shopify-section-"]').forEach(function(s){ s.classList.add('anim-in'); });
    document.addEventListener('shopify:section:load', function(e){ e.target.classList.add('anim-in'); });
  } else if('IntersectionObserver' in window){
    var secs = $$('[id^="shopify-section-"]');
    var io = new IntersectionObserver(function(es){
      es.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('anim-in'); io.unobserve(en.target); } });
    }, {rootMargin:'0px 0px -8% 0px'});
    secs.forEach(function(s){ io.observe(s); });
  } else {
    $$('[id^="shopify-section-"]').forEach(function(s){ s.classList.add('anim-in'); });
  }

  /* ---- Back to top ---- */
  var bt = $('[data-back-top]');
  if(bt){
    window.addEventListener('scroll', function(){
      bt.classList.toggle('show', window.scrollY > 600);
    }, {passive:true});
    bt.addEventListener('click', function(){ window.scrollTo({top:0, behavior:'smooth'}); });
  }

  /* ---- Sticky mobile add-to-cart ---- */
  var atc = $('[data-sticky-atc]');
  var buyRow = $('.pdp__buy-row');
  if(atc && buyRow && 'IntersectionObserver' in window){
    var io2 = new IntersectionObserver(function(es){
      es.forEach(function(en){ atc.classList.toggle('show', !en.isIntersecting && window.innerWidth < 861); });
    });
    io2.observe(buyRow);
  }

  /* ---- Variant picker (pills) — live preview of price, image, SKU, stock ---- */
  $$('[data-variant-picker]').forEach(function(picker){
    var jsonEl = $('[data-variant-json]', picker);
    if(!jsonEl) return;
    var variants;
    try{ variants = JSON.parse(jsonEl.textContent); }catch(e){ return; }
    var idInput = $('[data-variant-id]', picker);
    var scope = picker.closest('.pdp') || document;
    var priceEl = $('[data-price]', scope);
    var compareEl = $('[data-compare]', scope);
    var badgeEl = $('[data-save-badge]', scope);
    var skuEl = $('[data-sku]', scope);
    var stockEl = $('[data-stock]', scope);
    var mainImg = $('[data-gallery-main] img');
    var ratingEl = $('[data-rating-widget]', scope);
    var skuRatings = null;
    if(ratingEl){
      try{ skuRatings = JSON.parse(ratingEl.getAttribute('data-sku-ratings') || 'null'); }catch(e){ skuRatings = null; }
    }
    function updateRating(v){
      if(!ratingEl || !skuRatings || !v) return;
      var row = v.sku ? skuRatings[v.sku] : null;
      if(!row){
        ratingEl.style.display = ratingEl.getAttribute('data-rating-strict') === '1' ? 'none' : '';
        return;
      }
      ratingEl.style.display = '';
      var r = parseFloat(row.rating != null ? row.rating : row.value);
      var c = (row.count != null ? row.count : row.rating_count);
      var valEl = $('[data-rating-value]', ratingEl);
      var cntEl = $('[data-rating-count]', ratingEl);
      var starEl = $('[data-rating-stars]', ratingEl);
      if(valEl && !isNaN(r)) valEl.textContent = (Math.round(r * 10) / 10);
      if(cntEl && c != null) cntEl.textContent = c;
      if(starEl && !isNaN(r)) starEl.style.setProperty('--rt-pct', (r * 20) + '%');
    }

    function selectedOptions(){
      var opts = [];
      $$('input[type="radio"]:checked', picker).forEach(function(r){
        opts[parseInt(r.getAttribute('data-option-index'),10)] = r.value;
      });
      return opts;
    }
    function findVariant(opts){
      return variants.find(function(v){
        return v.options.every(function(o,i){ return o === opts[i]; });
      });
    }
    function apply(){
      var opts = selectedOptions();
      /* pill active state + selected value labels */
      $$('[data-option-pill]', picker).forEach(function(p){
        var input = $('input', p);
        p.classList.toggle('is-active', input.checked);
      });
      $$('[data-selected-value]', picker).forEach(function(s){
        var i = parseInt(s.getAttribute('data-selected-value'),10);
        if(opts[i]) s.textContent = opts[i];
      });
      var v = findVariant(opts);
      if(!v) return;
      if(idInput) idInput.value = v.id;
      if(priceEl) priceEl.textContent = v.price;
      if(compareEl && badgeEl){
        if(v.compare){
          compareEl.textContent = v.compare;
          compareEl.style.display = '';
        }else{
          compareEl.style.display = 'none';
          badgeEl.style.display = 'none';
        }
      }
      if(skuEl) skuEl.textContent = v.sku || '—';
      if(stockEl){
        stockEl.textContent = '';
        stockEl.innerHTML = v.available ? stockEl.getAttribute('data-in-stock-label') : stockEl.getAttribute('data-sold-out-label');
        stockEl.style.color = v.available ? stockEl.getAttribute('data-in-stock-color') : stockEl.getAttribute('data-sold-out-color');
      }
      if(mainImg && v.image){ mainImg.src = v.image; }
      updateRating(v);
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v, cents: v.price_cents }, bubbles: true }));
      /* disable submit if unavailable */
      var form = picker.closest('form');
      if(form){
        $$('button[type="submit"]', form).forEach(function(b){ b.disabled = !v.available; });
      }
    }
    picker.addEventListener('change', apply);
    apply();
  });

  /* ---- Product info tabs ---- */
  $$('[data-tabs]').forEach(function(wrap){
    $$('[data-tab-btn]', wrap).forEach(function(btn){
      btn.addEventListener('click', function(){
        var key = btn.getAttribute('data-tab-btn');
        $$('[data-tab-btn]', wrap).forEach(function(b){ b.classList.toggle('is-active', b === btn); });
        $$('[data-tab-pane]', wrap).forEach(function(p){
          p.classList.toggle('is-active', p.getAttribute('data-tab-pane') === key);
        });
      });
    });
  });

})();

/* ---- Brands directory: live search filter ---- */
(function(){
  var inp = document.querySelector('[data-brand-search]');
  if(!inp) return;
  inp.addEventListener('input', function(){
    var q = inp.value.trim().toLowerCase();
    document.querySelectorAll('[data-brand-name]').forEach(function(card){
      card.style.display = !q || (card.getAttribute('data-brand-name')||'').indexOf(q) > -1 ? '' : 'none';
    });
  });
})();

/* ---- Cart drawer: AJAX add-to-cart, live updates, side popup ---- */
(function(){
  var drawer = document.querySelector('[data-cart-drawer]');
  if(!drawer || drawer.getAttribute('data-enabled') !== 'true') return;

  function open(){ drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  function close(){ drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }

  function refresh(openAfter){
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html,'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        if(fresh){
          var isOpen = drawer.getAttribute('aria-hidden') === 'false';
          drawer.innerHTML = fresh.innerHTML;
          if(isOpen || openAfter) open();
        }
        return fetch('/cart.js').then(function(r){ return r.json(); });
      })
      .then(function(cart){
        if(!cart) return;
        document.querySelectorAll('.icon-btn .count').forEach(function(c){ c.textContent = cart.item_count; });
      })
      .catch(function(){});
  }

  /* Open from header cart icon */
  document.addEventListener('click', function(e){
    var cartLink = e.target.closest('a.icon-btn[href*="/cart"]');
    if(cartLink){ e.preventDefault(); refresh(true); return; }
    if(e.target.closest('[data-cart-drawer-close]')) close();
    if(e.target.closest('[data-cart-open]')){ e.preventDefault(); refresh(true); }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });

  /* Intercept product add-to-cart forms */
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!(form.getAttribute('action')||'').match(/\/cart\/add/)) return;
    /* let Buy-now (checkout) submit normally */
    var submitter = e.submitter;
    if(submitter && submitter.name === 'checkout') return;
    e.preventDefault();
    var fd = new FormData(form);
    if(submitter && submitter.name) fd.append(submitter.name, submitter.value || '');
    fetch('/cart/add.js', { method:'POST', body: fd })
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){ return refresh(true); })
      .catch(function(){ form.submit(); });
  }, true);

  /* Quantity +/- and remove inside drawer (event delegation survives re-render) */
  drawer.addEventListener('click', function(e){
    var qbtn = e.target.closest('[data-cd-qty]');
    var rbtn = e.target.closest('[data-cd-remove]');
    if(!qbtn && !rbtn) return;
    var key, qty;
    if(qbtn){
      key = qbtn.getAttribute('data-cd-qty');
      var span = qbtn.parentElement.querySelector('span');
      qty = Math.max(0, (parseInt(span.textContent,10)||0) + parseInt(qbtn.getAttribute('data-dir'),10));
    } else {
      key = rbtn.getAttribute('data-cd-remove'); qty = 0;
    }
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id:key, quantity:qty })
    }).then(function(){ refresh(false); });
  });
})();
